export const selectInsurance = state => state.insurances;
export const selectInsuranceDetail = state => selectInsurance(state).detail;
export const selectInsuranceList = state => selectInsurance(state).items;
export const selectInsuranceListCount = state => selectInsurance(state).count;
export const selectInsuranceEquipments = state =>
  selectInsurance(state).equipments;
export const selectInsuranceEquipmentCount = state =>
  selectInsurance(state).equipmentCount;
export const selectInsuranceQueryOptions = state => {
  const { options } = selectInsurance(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};

export const selectInsuranceEquipmentQueryOptions = state => {
  const { equipmentOptions } = selectInsurance(state);

  const options = equipmentOptions || {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
  };
  const cleanOptions = { ...options };

  Object.keys(cleanOptions).forEach(key => {
    if (cleanOptions[key] === '') {
      delete cleanOptions[key];
    }
  });

  return cleanOptions;
};
